import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { memoriesApi } from 'src/Services/API';
import { MemoryKind } from 'src/Services/API/Memories.api';

export const memoriesQueryKey = (assetId: string | undefined) => ['memories', assetId] as const;

const useFetchMemories = (filters: { kind?: MemoryKind; withVoice?: boolean } = {}) => {
  const assetId = useCurrentAssetId();

  return useQuery({
    queryKey: [...memoriesQueryKey(assetId), filters.kind ?? 'all', !!filters.withVoice],
    queryFn: async () => {
      if (!assetId) throw new Error('No assetId provided');
      return memoriesApi.timeline(assetId, {
        kind: filters.kind,
        withVoice: filters.withVoice || undefined,
      });
    },
    enabled: !!assetId,
    keepPreviousData: true,
  });
};

export default useFetchMemories;
